import React from 'react'
import List from '../list'
import hooks from '../../../hooks'

const LocationsDashboard = () => {
    const { isAdmin } = hooks.useCurrentUser()
    if (!isAdmin) {
        return null
    }
    return (
        <div style={{ padding: '20px'}}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignContent: 'center',
                }}
            >
                <h1>Locations</h1>
            </div>
            
            <List />
        </div>
    )
}

export default LocationsDashboard